<template>
  <div v-if="isOnboardingAvailable" class="mt-3">
    <v-tooltip
      location="right"
      text="Continue where you left off"
    >
      <template #activator="{ props: tooltipProps }">
        <v-list-item
          v-bind="tooltipProps"
          density="compact"
          link
          class="text-white onboarding-menu-item"
          min-height="68"
          @click="openOnboarding"
        >
          <template v-if="isCollapsed">
            <v-list-item-title class="text-uppercase onboarding-item-title" >
              <v-progress-circular
                v-bind="progressCircularBind"
                class="flex-shrink-0"
              />
              <div class="secondary--font mt-1 text-center steps-count">
                {{ completedStepsDisplay }}/{{ totalStepsDisplay }}
              </div>
            </v-list-item-title>
          </template>
          <template v-else>
            <v-list-item-title class="text-uppercase font-weight-bold onboarding-item-title-expanded">
              <div class="text-body-2 secondary--font mb-1">Get Started</div>
              <div class="text-caption secondary--font">
                <v-progress-circular
                  v-bind="progressCircularBind"
                  class="mr-2 flex-shrink-0"
                />
                {{ completedStepsDisplay }}/{{ totalStepsDisplay }} Completed
              </div>
            </v-list-item-title>
          </template>
        </v-list-item>
      </template>
    </v-tooltip>
    <v-divider />
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { navigateToUrl } from 'single-spa';
  import { useUserStore } from '@/lib/stores';
  import { onBoardingService } from '@/lib/services/onBoardingService';

  const ONBOARDING_PRODUCTS = ['marketing', 'service', 'commerce'] as const;

  const userStore = useUserStore();

  const isCollapsed = computed(() => userStore.isNavigationRail);

  const progressCircularBind = computed(() => ({
    modelValue: onBoardingService.getOnboardingCompletedPercentage.value ?? 0,
    size: 22,
    width: 3,
    color: 'mpBlue',
    bgColor: 'grey',
  }));

  const completedStepsDisplay = computed(
    () => onBoardingService.getOnboardingCompletedSteps.value ?? 0,
  );

  const totalStepsDisplay = computed(
    () => onBoardingService.getOnboardingTotalSteps.value ?? 0,
  );

  const isOnboardingAvailable = computed(() => {
    const hasAccess = ONBOARDING_PRODUCTS.some((product) =>
      userStore.getProductAccess(product),
    );
    return hasAccess && !onBoardingService.isOnboardingCompleted.value;
  });

  function openOnboarding() {
    navigateToUrl(`/accounts/${userStore.getAccountId}/onboarding`);
  }
</script>

<style scoped>
  .steps-count {
    font-size: 8px;
  }

  .onboarding-menu-item {
    padding: unset !important;
    padding-left: 8px !important;
  }

  .onboarding-item-title {
    display: grid;
    align-items: center;
    justify-items: center;
  }
  
  .onboarding-item-title-expanded {
    padding-left: 14px;
  }
</style>
